export const environment = {
	production: false,
	url: "https://api-shopeefood-claims.policystreet.app",
};
